module.exports = __webpack_public_path__ + "static/media/aiva_nudges.e8564811.jpg";